import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import NavigateBackButton from "../../shared/components/customNavigateButton/customNavigateButton";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import store from "../../store/store";
import { generateThreeWay, updateOrderStatus } from "../../store/api/order";
import {
  DISCOUNT_ITEM_TYPES,
  MESSAGE_TYPES,
  Order_Contact_Purpose_Type,
  PAGES_URL,
  SURPLUS_ITEM_TYPES,
  THREE_WAY_MATCH_STATUS,
} from "../../shared/constants/constants";
import PermissionsGate, {
  RoleBasedPermissionsGate,
} from "../../components/privateRoute/permissionsGate";
import {
  PLATFORM_PERMISSIONS,
  PLATFORM_ROLES,
} from "../../shared/models/abacConfig";
import { error } from "console";
import { isValidStringInput } from "../../shared/utils/validator";
import PageMessage from "../../components/pageMessage/pageMessage";
import "./threeWayMatch.scss";
import CustomSpinner from "../../shared/components/customSpinner/customSpinner";
import DownloadIcon from "../../shared/assets/Download.svg"
import FilePreviewDialog from "../../components/dialogBox/filePreviewDialog";

const ThreeWayMatch = () => {
  const location = useLocation();
  const orderId = location.state?.orderId;
  const mode = location.state?.mode;
  const invoiceLink = location.state?.invoiceLink;
  const navigate = useNavigate();

  const [orderDetails, setOrderDetails] = useState<any>({});
  const [grnDetails, setGrnDetails] = useState<any[]>([]);
  const [invoiceList, setInvoiceList] = useState<any[]>([]);
  const [invoiceItems, setInvoiceItems] = useState<any>({});
  const [includedOrderItems, setIncludedOrderItems] = useState<
    Set<number | string>
  >(new Set());
  const [includedInvoiceItems, setIncludedInvoiceItems] = useState<
    Set<number | string>
  >(new Set());
  const [grnItems, setGrnItems] = useState<any>({});
  const [orderItems, setOrderItems] = useState<any>({});
  const [threeWayMatrix, setThreeWayMatrix] = useState<any>({});
  const [orderContactMechs, setOrderContactMechs] = useState<any>({});
  const [orderItemBillingList, setOrderItemBillingList] = useState<any[]>([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState<any>({
    open: false,
    status: "",
    updateItem: "",
  });
  const [currentGRN, setCurrentGRN] = useState<any>({
    ids: [],
    quantity: 0,
  });
  const [currentInvoice, setCurrentInvoice] = useState<any>({
    ids: [],
    quantity: 0,
    subTotal: 0,
    tax: 0,
    grandTotal: 0,
  });
  const [comment, setComment] = useState<any>({
    value: "",
    error: false,
    empty: false,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState({
    message: "",
    open: false,
    variant: "success",
  });
  const [hasUnmatchedItems, setHasUnmatchedItems] = useState<boolean>(false);
  const [openPdfViewer, setOpenPdfViewer] = useState<{ open: boolean, pdfUrl: string, fileType: string }>({ open: false, pdfUrl: "", fileType: "" });

  useEffect(() => {
    setIsLoading(true);
    store
      .dispatch(generateThreeWay({ orderId: orderId }))
      .unwrap()
      .then((res: any) => {
        if (res?.data?.threeWayMatchResult) {
          const threeWayMatchResult = res.data.threeWayMatchResult;
          setOrderDetails({ ...threeWayMatchResult?.order });
          setGrnDetails([...threeWayMatchResult?.grns]);
          setInvoiceList([...threeWayMatchResult?.invoiceList]);
          setInvoiceItems({ ...threeWayMatchResult?.invoiceItems });
          setGrnItems({ ...threeWayMatchResult?.grnItems });
          setOrderItems({ ...threeWayMatchResult?.orderItems });
          setOrderItemBillingList([
            ...threeWayMatchResult?.orderItemBillingList,
          ]);
          setThreeWayMatrix({ ...threeWayMatchResult?.threeWayMatrix });
          const orderContactMechs: any = {};
          threeWayMatchResult?.order?.contactMechs?.forEach(
            (contactMech: any) => {
              orderContactMechs[contactMech?.purposeType] = contactMech?.detail;
            }
          );
          setOrderContactMechs(orderContactMechs);
          let totalQuant = 0;
          let grnIds: any[] = [];
          threeWayMatchResult?.grns?.forEach((grn: any) => {
            totalQuant += grn?.items?.reduce(
              (accumulator: number, currentValue: any) => {
                return accumulator + currentValue.quantity;
              },
              0
            );
            grnIds.push(grn?._id);
          });
          setCurrentGRN({
            ids: grnIds,
            quantity: totalQuant,
          });

          let totalInvQuant = 0;
          let subtotalInv = 0;
          let taxInv = 0;
          let grandTotalInv = 0;
          let invIds: any[] = [];

          threeWayMatchResult?.invoiceList?.forEach((invoice: any) => {
            invoice?.invoiceItems?.forEach((item: any) => {
              const itemSubtotal = item?.quantity * item?.unitPrice;
              const itemTax = itemSubtotal * (item?.percentageGst / 100);
              totalInvQuant += item?.quantity;
              subtotalInv += itemSubtotal;
              taxInv += itemTax;
              grandTotalInv += item?.amount;
            });
            invIds.push(invoice?.invoiceId);
          });

          const orderItemIds: Set<number | string> = new Set<number | string>();
          const invoiceItemIds: Set<number | string> = new Set<number | string>();
          threeWayMatchResult?.orderItemBillingList?.forEach((item: any) => {
            orderItemIds.add(item?.orderItemSeqId);
            if(item?.orderItemSeqId){
              invoiceItemIds.add(item?.invoiceId+"-"+item?.invoiceItemSeqId);
            }
          });
          setIncludedOrderItems(orderItemIds);
          setIncludedInvoiceItems(invoiceItemIds);

          setCurrentInvoice({
            ids: [...invIds],
            quantity: totalInvQuant,
            subTotal: subtotalInv,
            tax: taxInv,
            grandTotal: grandTotalInv,
          });

          let unmatchedItems = false;
          Object.keys(threeWayMatchResult?.threeWayMatrix)?.forEach(
            (itemId: string) => {
              if (
                !threeWayMatchResult?.threeWayMatrix[itemId]?.order ||
                !threeWayMatchResult?.threeWayMatrix[itemId]?.grn ||
                !threeWayMatchResult?.threeWayMatrix[itemId]?.invoice
              ) {
                unmatchedItems = true;
              }
            }
          );
          setHasUnmatchedItems(unmatchedItems);
        }
      })
      .catch((err: any) => {
        handleSnack("Error fetching three way match data", "error");
        console.error("Error fetching three way match data: ", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const handleSnack = (message: string, variant: string) => {
    setOpenSnack({ message: message, open: true, variant: variant });
  };

  const handleCloseSnack = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnack({ ...openSnack, open: false });
  };

  const handleChangeGRN = (event: SelectChangeEvent<any>) => {
    const {
      target: { value },
    } = event;

    const grnIds = typeof value === "string" ? value.split(",") : value;

    let totalQuant = 0;
    grnDetails
      ?.filter((grn: any) => grnIds?.includes(grn?._id))
      ?.forEach((grn: any) => {
        totalQuant += grn?.items?.reduce(
          (accumulator: number, currentValue: any) => {
            return accumulator + currentValue.quantity;
          },
          0
        );
      });
    setCurrentGRN({
      ids: typeof value === "string" ? value.split(",") : value,
      quantity: totalQuant,
    });
  };

  const handleChangeInvoice = (event: SelectChangeEvent<any>) => {
    const {
      target: { value },
    } = event;

    const invoiceIds = typeof value === "string" ? value.split(",") : value;

    let totalQuant = 0;
    let subtotal = 0;
    let tax = 0;
    let grandTotal = 0;
    invoiceList
      ?.filter((invoice: any) => invoiceIds?.includes(invoice?.invoiceId))
      ?.forEach((invoice: any) => {
        invoice?.invoiceItems?.forEach((item: any) => {
          const itemSubtotal = item?.quantity * item?.unitPrice;
          const itemTax = itemSubtotal * (item?.percentageGst / 100);
          totalQuant += item?.quantity;
          subtotal += itemSubtotal;
          tax += itemTax;
          grandTotal += item?.amount;
        });
      });

    setCurrentInvoice({
      ids: typeof value === "string" ? value.split(",") : value,
      quantity: totalQuant,
      subTotal: subtotal,
      tax: tax,
      grandTotal: grandTotal,
    });
  };

  const handleThreeWayAction = (status: any, updateItem: string) => {
    if (comment?.value === "") {
      setComment({
        ...comment,
        error: false,
        empty: true,
      });
      return;
    }
    if (!isValidStringInput(comment?.value)) {
      // setIsLoading(false);
      setComment({
        ...comment,
        error: true,
      });
      return;
    }
    setOpenConfirmationDialog({
      open: true,
      status: status,
      updateItem: updateItem,
    });
  };

  const handleStatus = async (status: any, updateItem: string) => {
    setIsLoading(true);
    let reqBody: any = {
      orderId: orderDetails?._id,
      status: orderDetails?.statusId,
      comments: comment?.value,
      invoiceIdList: invoiceList?.map((invoice: any) => {
        return invoice?.invoiceId;
      }),
    };
    if (updateItem === "threeWay") {
      reqBody = { ...reqBody, threeWayMatchResult: status };
    }
    await store
      .dispatch(updateOrderStatus(reqBody))
      .unwrap()
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          handleSnack("Updated Status Successfully", "success");
          setTimeout(() => {
            navigate(
              `${PAGES_URL.ORDERMGR}/${PAGES_URL.ORDER_DETAILS}/${orderDetails._id}`
            );
          }, 1000);
        } else {
          handleSnack("Update Status Failed", "error");
        }
      })
      .catch(() => {
        handleSnack("Update Status Failed", "error");
      })
      .finally(() => {
        setIsLoading(false);
        setOpenConfirmationDialog({
          open: false,
          status: "",
          updateItem: "",
        });
      });
  };

  const getInvoiceFileName = () => {
    if (invoiceLink?.objectInfo) {
      const mainURL = invoiceLink?.objectInfo?.split("?")[0]
      const minURLarr = mainURL?.split("/")
      const fileName = minURLarr[minURLarr.length - 1];
      const fileNameArr = fileName?.split("-")
      fileNameArr?.shift();
      // console.log("File Name: ", fileNameArr?.join("-"));
      return fileNameArr?.join("-") || "Invoice";
    }
    return "Invoice"
  }

  const downloadInvoiceImage = () => {
    if (invoiceLink?.mimeTypeId?.split("/")?.[0] === "image") {
      setOpenPdfViewer({ open: true, pdfUrl: invoiceLink?.objectInfo, fileType: invoiceLink?.mimeTypeId?.split("/")?.[1] });
    }
    else {
      const a = document.createElement("a");
      a.href = invoiceLink?.objectInfo;
      a.download = getInvoiceFileName() || "invoice";
      a.target = "_blank";
      a.click();
    }
  }

  const confirmationDialog = useMemo(() => {
    return (
      <Dialog
        open={openConfirmationDialog.open}
        onClose={() =>
          setOpenConfirmationDialog({ open: false, status: "", updateItem: "" })
        }
      >
        <Box p={2}>
          <DialogTitle>
            <Box>
              <Typography fontWeight={600} color={"#000000"} fontSize={18}>
                {"Confirm Action"}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Box>
                {openConfirmationDialog.status ===
                  THREE_WAY_MATCH_STATUS.APPROVED && (
                  <Typography
                    fontWeight={400}
                    color={"#000000"}
                    sx={{ whiteSpace: "pre-line" }}
                  >
                    {"Are you sure you want to approve this order"}
                  </Typography>
                )}
                {openConfirmationDialog.status ===
                  THREE_WAY_MATCH_STATUS.REJECTED && (
                  <Typography
                    fontWeight={400}
                    color={"#000000"}
                    sx={{ whiteSpace: "pre-line" }}
                  >
                    {"Are you sure you want to reject this order"}
                  </Typography>
                )}
              </Box>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box className="buttonGroup">
              <Button
                variant="contained"
                onClick={() => {
                  handleStatus(
                    openConfirmationDialog.status,
                    openConfirmationDialog.updateItem
                  );
                }}
                autoFocus
                sx={{
                  p: 2,
                  borderRadius: 0,
                  width: "88px",
                  height: "34px",
                  mr: 2,
                }}
              >
                <Typography>Confirm</Typography>
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  setOpenConfirmationDialog({
                    open: false,
                    status: "",
                    updateItem: "",
                  })
                }
                sx={{ p: 2, borderRadius: 0, width: "88px", height: "34px" }}
              >
                <Typography>Cancel</Typography>
              </Button>
            </Box>
          </DialogActions>
        </Box>
      </Dialog>
    );
  }, [openConfirmationDialog, comment]);

  const comparatorElement = useMemo(() => {
    return (
      <Stack direction={{ sm: "column", md: "row" }} spacing={1} p={1}>
        {/* -------------------------------------   PO SECTION ------------------------------------------- */}
        <Stack
          width={{
            sm: 1,
            md: grnDetails && grnDetails.length > 0 ? 1 / 3 : 1 / 2,
          }}
          spacing={1}
          minHeight={"70vh"}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Box>
            <Stack>
              <Box p={1}>
                <Typography fontWeight={700} fontSize={32}>
                  Purchase Order
                </Typography>
              </Box>
              <Stack direction={"row"} spacing={1} p={1}>
                <Stack direction={"row"}>
                  <Typography fontWeight={700} fontSize={14}>
                    PO: &nbsp;
                  </Typography>
                  <Typography fontWeight={400} fontSize={14}>
                    {orderDetails?.referenceNumber &&
                    orderDetails?.referenceNumber !== ""
                      ? orderDetails?.referenceNumber
                      : (orderDetails?.orderCode
                          ? orderDetails?.orderCode.split("/")[5]
                          : orderDetails?._id) ?? "-"}
                  </Typography>
                </Stack>
                <Divider orientation="vertical" flexItem />
                <Stack direction={"row"}>
                  <Typography fontWeight={700} fontSize={14}>
                    Date: &nbsp;
                  </Typography>
                  <Typography fontWeight={400} fontSize={14}>
                    {new Date(orderDetails?.createdDate).toLocaleDateString(
                      "en-US",
                      {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      }
                    )}
                  </Typography>
                </Stack>
              </Stack>
              {/* <Divider orientation="horizontal" flexItem sx={{ borderBottomWidth: 2, borderColor: "#000000" }} />
                            <Stack direction={"row"} spacing={1} p={1}>
                                <Stack width={1/2}>
                                    <Typography fontWeight={700} fontSize={14}>Bill To:</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderDetails?.fromPartyId?.details?.groupName || "-"}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderContactMechs[Order_Contact_Purpose_Type.PRIMARY_PHONE] || "-"}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderContactMechs[Order_Contact_Purpose_Type.PRIMARY_PHONE] || "-"}</Typography>
                                </Stack>
                                <Divider orientation="vertical" flexItem/>
                                <Stack width={1/2}>
                                    <Typography fontWeight={700} fontSize={14}>Payment Information: &nbsp;</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                </Stack>
                            </Stack> */}
            </Stack>
            <Stack>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
              />
              <Stack direction={"row"} spacing={1} p={1}>
                <Box width={2 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    DESCRIPTION
                  </Typography>
                </Box>
                <Box width={1 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    QTY
                  </Typography>
                </Box>
                <Box width={1 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    PRICE
                  </Typography>
                </Box>
                <Box width={1 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    TOTAL
                  </Typography>
                </Box>
              </Stack>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
              />
              <Stack spacing={0.5}>
                {Object.keys(orderItems)?.map((itemId: string) => {
                  return (
                    <Stack
                      direction={"row"}
                      p={1}
                      spacing={1}
                      key={itemId}
                      sx={{
                        backgroundColor: threeWayMatrix[itemId]?.order
                          ? "#F4FFE5"
                          : "#FFDADB",
                      }}
                    >
                      <Box width={2 / 5}>
                        <Typography fontWeight={400} fontSize={14}>
                          {orderItems[itemId]?.item}
                        </Typography>
                      </Box>
                      <Box width={1 / 5}>
                        <Typography fontWeight={400} fontSize={14}>
                          {orderItems[itemId]?.quantity}
                        </Typography>
                      </Box>
                      <Box width={1 / 5}>
                        <Typography fontWeight={400} fontSize={14}>
                          {orderItems[itemId]?.unitPrice?.toLocaleString(
                            "en-IN",
                            {
                              maximumFractionDigits: 2,
                              style: "currency",
                              currency: "INR",
                            }
                          )}
                        </Typography>
                      </Box>
                      <Box width={1 / 5}>
                        <Typography fontWeight={400} fontSize={14}>
                          {orderItems[itemId]?.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 2,
                            style: "currency",
                            currency: "INR",
                          })}
                        </Typography>
                      </Box>
                    </Stack>
                  );
                })}

                {invoiceList
                  ?.filter((invoice: any) =>
                    currentInvoice?.ids?.includes(invoice?.invoiceId)
                  )
                  ?.map((invoice: any) => {
                    return invoice?.invoiceItems
                      ?.filter(
                        (item: any) =>
                          !includedInvoiceItems.has(
                            invoice?.invoiceId + "-" + item?.invoiceItemSeqId
                          ) &&
                          ![
                            ...DISCOUNT_ITEM_TYPES,
                            ...SURPLUS_ITEM_TYPES,
                          ].includes(item?.invoiceItemTypeId)
                      )
                      ?.map((item: any) => {
                        return (
                          <Stack
                            direction={"row"}
                            p={1}
                            spacing={1}
                            key={item?.itemSeqId}
                            sx={{
                              backgroundColor: threeWayMatrix[
                                Number(
                                  orderItemBillingList?.find(
                                    (bill) =>
                                      bill?.invoiceId === invoice?.invoiceId &&
                                      bill?.invoiceItemSeqId ==
                                        item?.invoiceItemSeqId
                                  )?.orderItemSeqId
                                )
                              ]?.invoice
                                ? "#F4FFE5"
                                : "#FFDADB",
                            }}
                          >
                            <Box width={2 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.itemName}
                              </Typography>
                            </Box>
                            <Box width={3 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {"Item not present in PO"}
                              </Typography>
                            </Box>
                          </Stack>
                        );
                      });
                  })}
              </Stack>
            </Stack>
          </Box>
          {/* <Box height={"30px"} ></Box> */}
          <Stack>
            <Stack direction={"row"} spacing={1} p={1}>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  SUBTOTAL
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  TOTAL QTY
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  TAX
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  TOTAL
                </Typography>
              </Box>
            </Stack>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
            />
            <Stack
              direction={"row"}
              spacing={1}
              p={1}
              sx={{
                backgroundColor: threeWayMatrix["Totals"]?.order
                  ? "#F4FFE5"
                  : "#FFDADB",
              }}
            >
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {orderDetails?.totalAmount?.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  }) || 0}
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {orderDetails?.items?.reduce(
                    (accumulator: number, currentValue: any) => {
                      return accumulator + currentValue.quantity;
                    },
                    0
                  ) || 0}
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {orderDetails?.totalTaxAmount?.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  }) || 0}
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {orderDetails?.grandTotal?.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  }) || 0}
                </Typography>
              </Box>
            </Stack>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
            />
          </Stack>
        </Stack>

        <Divider orientation="vertical" flexItem />
        {/* -------------------------------------   GRN SECTION ------------------------------------------- */}
        {grnDetails && grnDetails?.length > 0 && (
          <Stack
            width={{ sm: 1, md: 1 / 3 }}
            minHeight={"70vh"}
            display={"flex"}
            spacing={1}
            justifyContent={"space-between"}
          >
            <Box>
              <Stack>
                <Box p={1}>
                  <Typography fontWeight={700} fontSize={32}>
                    GRN
                  </Typography>
                </Box>
                <Stack direction={"row"} p={1}>
                  <Typography fontWeight={700} fontSize={14}>
                    GRN: &nbsp;
                  </Typography>
                  <Select
                    multiple
                    value={currentGRN?.ids}
                    onChange={handleChangeGRN}
                    input={<OutlinedInput />}
                    sx={{ height: "20px" }}
                  >
                    {grnDetails?.map((grn: any) => (
                      <MenuItem key={grn?._id} value={grn?._id}>
                        {grn?.goodsReqChallanCode?.split("/")[3] ||
                          grn?.goodsReqChallanCode}
                      </MenuItem>
                    ))}
                  </Select>
                </Stack>
                {/* <Divider orientation="horizontal" flexItem sx={{ borderBottomWidth: 2, borderColor: "#000000" }} />
                            <Stack direction={"row"} spacing={1} p={1}>
                                <Stack width={1/2}>
                                    <Typography fontWeight={700} fontSize={14}>Delivered To:</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderDetails?.fromPartyId?.details?.groupName}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderContactMechs[Order_Contact_Purpose_Type.SHIPPING_LOCATION]}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderContactMechs[Order_Contact_Purpose_Type.PRIMARY_PHONE]}</Typography>
                                </Stack>
                                <Divider orientation="vertical" flexItem/>
                                <Stack width={1/2}>
                                    <Typography fontWeight={700} fontSize={14}>SUPPLIER: &nbsp;</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderDetails?.fulfilledByPartyId?.details?.groupName}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                </Stack>
                            </Stack> */}
              </Stack>
              <Stack>
                <Divider
                  orientation="horizontal"
                  flexItem
                  sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
                />
                <Stack direction={"row"} spacing={1} p={1}>
                  <Box width={2 / 5}>
                    <Typography fontWeight={700} fontSize={14}>
                      DESCRIPTION
                    </Typography>
                  </Box>
                  <Box width={1 / 5}>
                    <Typography fontWeight={700} fontSize={14}>
                      QTY
                    </Typography>
                  </Box>
                  <Box width={1 / 5}>
                    <Typography fontWeight={700} fontSize={14}>
                      PRICE
                    </Typography>
                  </Box>
                  <Box width={1 / 5}>
                    <Typography fontWeight={700} fontSize={14}>
                      TOTAL
                    </Typography>
                  </Box>
                </Stack>
                <Divider
                  orientation="horizontal"
                  flexItem
                  sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
                />
                <Stack spacing={0.5}>
                  {grnDetails
                    ?.filter((grn: any) => currentGRN?.ids?.includes(grn?._id))
                    ?.map((grn: any) => {
                      return grn?.items?.map((item: any) => {
                        return (
                          <Stack
                            direction={"row"}
                            p={1}
                            spacing={1}
                            key={item?.itemSeqId}
                            sx={{
                              backgroundColor: threeWayMatrix[item?.itemSeqId]
                                ?.grn
                                ? "#F4FFE5"
                                : "#FFDADB",
                            }}
                          >
                            <Box width={2 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.item}
                              </Typography>
                            </Box>
                            <Box width={1 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.deliveredQuantity}
                              </Typography>
                            </Box>
                            <Box width={1 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.unitPrice?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </Typography>
                            </Box>
                            <Box width={1 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.amount?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </Typography>
                            </Box>
                          </Stack>
                        );
                      });
                    })}
                </Stack>
              </Stack>
            </Box>
            {/* <Box height={"30px"} ></Box> */}
            <Stack>
              <Stack
                direction={"row"}
                spacing={1}
                p={1}
                display={"flex"}
                justifyContent={"flex-end"}
              >
                <Box width={1 / 4}>
                  <Typography fontWeight={700} fontSize={14}>
                    TOTAL QTY
                  </Typography>
                </Box>
              </Stack>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
              />
              <Stack
                direction={"row"}
                spacing={1}
                p={1}
                display={"flex"}
                justifyContent={"flex-end"}
                sx={{
                  backgroundColor: threeWayMatrix["Totals"]?.grn
                    ? "#F4FFE5"
                    : "#FFDADB",
                }}
              >
                <Box width={1 / 4}>
                  <Typography fontWeight={400} fontSize={14}>
                    {currentGRN?.quantity ?? 0}
                  </Typography>
                </Box>
              </Stack>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
              />
            </Stack>
          </Stack>
        )}

        {grnDetails && grnDetails?.length > 0 && (
          <Divider orientation="vertical" flexItem />
        )}
        {/* -------------------------------------   INVOICE SECTION ------------------------------------------- */}
        <Stack
          width={{
            sm: 1,
            md: grnDetails && grnDetails.length > 0 ? 1 / 3 : 1 / 2,
          }}
          spacing={1}
          minHeight={"70vh"}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Box>
            <Stack>
              <Box p={1} display={"flex"} justifyContent={"space-between"}>
                <Typography fontWeight={700} fontSize={32}>
                  Invoice
                </Typography>
                {invoiceLink && Object.keys(invoiceLink).length > 0 && (
                  <IconButton
                    sx={{
                      borderRadius: 0,
                      p: 0,
                    }}
                    //  endIcon={<img src={DownloadIcon}/>}
                    onClick={() => downloadInvoiceImage()}
                    size="large"
                  >
                    <img height={"30px"} width={"30px"} src={DownloadIcon} />
                  </IconButton>
                )}
              </Box>
              <Stack direction={"row"} p={1}>
                <Typography fontWeight={700} fontSize={14}>
                  Invoice: &nbsp;
                </Typography>
                <Select
                  multiple
                  value={currentInvoice?.ids}
                  onChange={handleChangeInvoice}
                  input={<OutlinedInput />}
                  sx={{ height: "20px" }}
                >
                  {invoiceList?.map((invoice: any) => {
                    return (
                      <MenuItem
                        key={invoice?.invoiceId}
                        value={invoice?.invoiceId}
                      >
                        {invoice?.invoiceCode?.split("/")?.splice(-1)}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Stack>
              {/* <Divider orientation="horizontal" flexItem sx={{ borderBottomWidth: 2, borderColor: "#000000" }} />
                            <Stack direction={"row"} spacing={1} p={1}>
                                <Stack width={1/2}>
                                    <Typography fontWeight={700} fontSize={14}>Delivery:</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderDetails?.fromPartyId?.details?.groupName || "-"}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderContactMechs[Order_Contact_Purpose_Type.PRIMARY_PHONE]}</Typography>
                                </Stack>
                                <Divider orientation="vertical" flexItem/>
                                <Stack width={1/2}>
                                    <Typography fontWeight={700} fontSize={14}>Payment Information: &nbsp;</Typography>
                                    <Typography fontWeight={400} fontSize={14}>{orderDetails?.fulfilledByPartyId?.details?.groupName || "-"}</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                    <Typography fontWeight={400} fontSize={14}>-</Typography>
                                </Stack>
                            </Stack> */}
            </Stack>
            <Stack>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
              />
              <Stack direction={"row"} spacing={1} p={1}>
                <Box width={2 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    DESCRIPTION
                  </Typography>
                </Box>
                <Box width={1 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    QTY
                  </Typography>
                </Box>
                <Box width={1 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    PRICE
                  </Typography>
                </Box>
                <Box width={1 / 5}>
                  <Typography fontWeight={700} fontSize={14}>
                    TOTAL
                  </Typography>
                </Box>
              </Stack>
              <Divider
                orientation="horizontal"
                flexItem
                sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
              />
              {invoiceList.length === 0 ? (
                <Stack p={2} bgcolor={"#FFDADB"}>
                  <Typography fontWeight={400} fontSize={14}>
                    System failed to read any items from invoice. Please upload
                    a readable invoice and try again. You can also proceed
                    manually by downloading the uploaded invoice
                  </Typography>
                </Stack>
              ) : (
                <Stack spacing={0.5}>
                  {invoiceList
                    ?.filter((invoice: any) =>
                      currentInvoice?.ids?.includes(invoice?.invoiceId)
                    )
                    ?.map((invoice: any) => {
                      return invoice?.invoiceItems?.map((item: any) => {
                        return (
                          <Stack
                            direction={"row"}
                            p={1}
                            spacing={1}
                            key={item?.itemSeqId}
                            sx={{
                              backgroundColor: threeWayMatrix[
                                DISCOUNT_ITEM_TYPES.includes(
                                  item?.invoiceItemTypeId
                                )
                                  ? `Adjustment_${item.invoiceItemSeqId}`
                                  : Number(
                                      orderItemBillingList?.find(
                                        (bill) =>
                                          bill?.invoiceId ===
                                            invoice?.invoiceId &&
                                          bill?.invoiceItemSeqId ==
                                            item?.invoiceItemSeqId
                                      )?.orderItemSeqId
                                    )
                              ]?.invoice
                                ? "#F4FFE5"
                                : "#FFDADB",
                            }}
                          >
                            <Box width={2 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.itemName}
                              </Typography>
                            </Box>
                            <Box width={1 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.quantity}
                              </Typography>
                            </Box>
                            <Box width={1 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {item?.unitPrice?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </Typography>
                            </Box>
                            <Box width={1 / 5}>
                              <Typography fontWeight={400} fontSize={14}>
                                {(item?.amount).toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </Typography>
                            </Box>
                          </Stack>
                        );
                      });
                    })}

                  {Object.keys(orderItems)
                    ?.filter(
                      (itemId: string) => !includedOrderItems.has(itemId)
                    )
                    ?.map((itemId: string) => {
                      return (
                        <Stack
                          direction={"row"}
                          p={1}
                          spacing={1}
                          key={itemId}
                          sx={{
                            backgroundColor: "#FFDADB",
                          }}
                        >
                          <Box width={2 / 5}>
                            <Typography fontWeight={400} fontSize={14}>
                              {orderItems[itemId]?.item}
                            </Typography>
                          </Box>
                          <Box width={2 / 5}>
                            <Typography fontWeight={400} fontSize={14}>
                              {"Item not in Invoice"}
                            </Typography>
                          </Box>
                          {/* <Box width={1 / 5}>
                          <Typography fontWeight={400} fontSize={14}>
                            {0}
                          </Typography>
                        </Box>
                        <Box width={1 / 5}>
                          <Typography fontWeight={400} fontSize={14}>
                            {orderItems[itemId]?.unitPrice?.toLocaleString(
                              "en-IN",
                              {
                                maximumFractionDigits: 2,
                                style: "currency",
                                currency: "INR",
                              }
                            )}
                          </Typography>
                        </Box>
                        <Box width={1 / 5}>
                          <Typography fontWeight={400} fontSize={14}>
                            {0?.toLocaleString("en-IN", {
                              maximumFractionDigits: 2,
                              style: "currency",
                              currency: "INR",
                            })}
                          </Typography>
                        </Box> */}
                        </Stack>
                      );
                    })}
                </Stack>
              )}
            </Stack>
          </Box>
          {/* <Box height={"30px"} ></Box> */}
          <Stack>
            <Stack direction={"row"} spacing={1} p={1}>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  SUBTOTAL
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  TOTAL QTY
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  TAX
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={700} fontSize={14}>
                  TOTAL
                </Typography>
              </Box>
            </Stack>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
            />
            <Stack
              direction={"row"}
              spacing={1}
              p={1}
              sx={{
                backgroundColor: threeWayMatrix["Totals"]?.order
                  ? "#F4FFE5"
                  : "#FFDADB",
              }}
            >
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {currentInvoice?.subTotal?.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  })}
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {currentInvoice?.quantity}
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {currentInvoice?.tax?.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  })}
                </Typography>
              </Box>
              <Box width={1 / 4}>
                <Typography fontWeight={400} fontSize={14}>
                  {currentInvoice?.grandTotal?.toLocaleString("en-IN", {
                    maximumFractionDigits: 2,
                    style: "currency",
                    currency: "INR",
                  })}
                </Typography>
              </Box>
            </Stack>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{ borderBottomWidth: 2, borderColor: "#000000" }}
            />
          </Stack>
        </Stack>
      </Stack>
    );
  }, [
    orderDetails,
    grnDetails,
    invoiceList,
    invoiceItems,
    grnItems,
    orderItems,
    threeWayMatrix,
    orderContactMechs,
    currentGRN,
    currentInvoice,
  ]);

  if (isLoading) {
    return <CustomSpinner size={"2rem"} />;
  }
  return (
    <Box
      flex={1}
      sx={{
        py: 4,
        mx: {
          xs: 2,
          sm: 4,
        },
      }}
    >
      <NavigateBackButton label="Back to Dashboard" navigateLink="/dashboard" />
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "row",
          },
          justifyContent: "space-between",
          alignContent: "center",
          my: 4,
        }}
      >
        <Typography variant="h4" fontWeight={"bold"} className="ROHeading">
          Repeat Order
        </Typography>
      </Box> */}

      <Box
        sx={{
          backgroundColor: "#fff",
          my: 2,
          boxShadow: 3,
          py: 4,
          display: "flex",
          flexDirection: "column",
          gap: 4,
        }}
      >
        {comparatorElement}
        {mode === "EDIT" && (
          <Box>
            <Stack spacing={1} p={1}>
              <Typography fontWeight={700} fontSize={18}>
                Comments*
              </Typography>
              <FormControl sx={{ width: { lg: "70%", sm: "85%", xs: "95%" } }}>
                <TextField
                  id={"Comment"}
                  // label="Other"
                  variant="filled"
                  multiline
                  rows={3}
                  error={comment.error}
                  helperText={
                    comment.error
                      ? "Please enter a valid comment"
                      : "Add any comments or notes regarding the three-way match"
                  }
                  value={comment.value}
                  onChange={(e) =>
                    setComment({
                      value: e.target.value.replace(/[^\x20-\x7E\n]/g, " "),
                      error:
                        e.target.value === ""
                          ? false
                          : !isValidStringInput(
                              e.target.value.replace(/[^\x20-\x7E\n]/g, " ")
                            ),
                    })
                  }
                />
              </FormControl>
            </Stack>
            <Stack
              p={1}
              width={{ lg: "70%", sm: "85%", xs: "95%" }}
              spacing={0.5}
            >
              {comment?.empty && (
                <PageMessage
                  type={MESSAGE_TYPES.ERROR}
                  content="You will not able to submit the request before adding comments request you to please add comments"
                />
              )}
              {hasUnmatchedItems && (
                <PageMessage
                  type={MESSAGE_TYPES.WARNING}
                  content="Request you to please validate the details above before making any action"
                />
              )}
            </Stack>
            <RoleBasedPermissionsGate roles={[PLATFORM_ROLES.SOCIETY]}>
              <PermissionsGate
                permissions={[
                  PLATFORM_PERMISSIONS.ORDER_THREE_WAY_MATCH_UPDATE,
                ]}
              >
                <Stack direction={"row"} gap={1} p={1}>
                  <Box className="buttonAccept">
                    <Button
                      variant="contained"
                      onClick={() =>
                        handleThreeWayAction(
                          THREE_WAY_MATCH_STATUS.APPROVED,
                          "threeWay"
                        )
                      }
                    >
                      <Typography variant="body1">Accept</Typography>
                    </Button>
                  </Box>
                  <Box className="buttonReject">
                    <Button
                      variant="contained"
                      onClick={() =>
                        handleThreeWayAction(
                          THREE_WAY_MATCH_STATUS.REJECTED,
                          "threeWay"
                        )
                      }
                    >
                      <Typography variant="body1">Reject</Typography>
                    </Button>
                  </Box>
                </Stack>
              </PermissionsGate>
            </RoleBasedPermissionsGate>
          </Box>
        )}
      </Box>
      {confirmationDialog}
      <Snackbar
        open={openSnack.open}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
      >
        {openSnack.variant === "success" ? (
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {openSnack.message}
          </Alert>
        ) : (
          <Alert
            onClose={handleCloseSnack}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {openSnack.message}
          </Alert>
        )}
      </Snackbar>
      <FilePreviewDialog
        open={openPdfViewer.open}
        fileUrl={openPdfViewer.pdfUrl}
        onClose={() => setOpenPdfViewer({ open: false, pdfUrl: '', fileType: '' })}
        fileType={(openPdfViewer.fileType as ('image' | "pdf"))}
      />
    </Box>
  );
};

export default ThreeWayMatch;
